export const inlineStyles = {
    impactDescription: {
        overflow: 'auto',
        fontFamily: 'Roboto500',
        fontSize: '12px',
    },
};
export default inlineStyles;
